import React from 'react';
import { Box, Card, CardMedia, IconButton, Typography } from '@mui/material';
import noImage from '@images/icons/no-image.jpg';
import { Add } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { TProduct } from '../../../types/Common';
import { cartSelector } from '../../../store/user/user.selector';
import { setCart } from '../../../store/user/user.reducer';
import commafy from '../../../utils/commafyHelper';
import './product.scss';

interface ProductCardProps {
  product: TProduct;
  setSelectProduct?: (product: TProduct) => void;
}

const ProductCard: React.FC<ProductCardProps> = (props) => {
  const dispatch = useDispatch();
  const { product, setSelectProduct } = props;
  const { productName, off = 0, price, productId, productPic } = product;
  const cart = useSelector(cartSelector) || [];

  const cartIds = cart.map((i: TProduct) => {
    return i.productId;
  });

  const disabled = cartIds.includes(productId);

  return (
    <Card className='productCardContainer'>
      <Box className='addContainer'>
        <IconButton
          sx={{ opacity: disabled ? '0.4' : '1', cursor: disabled ? 'not-allowed' : 'pointer' }}
          className='addBox'
          disableRipple
          onClick={() => !disabled && dispatch(setCart(product))}
        >
          <Add color='inherit' />
        </IconButton>
      </Box>

      <Box className='flexCenter'>
        <CardMedia
          sx={{ height: 160, width: 160, borderRadius: '0.6rem' }}
          image={productPic || noImage}
          title=''
        />
      </Box>

      <Typography color='text.main' fontWeight='bold' mt={1}>
        {productName}
      </Typography>

      <Box className='spaceBetween' mt={2}>
        <IconButton disableRipple onClick={() => setSelectProduct?.(product)}>
          <Typography color='primary.main' fontWeight='bold' fontSize='small'>
            توضیحات بیشتر
          </Typography>
        </IconButton>

        <Box>
          <Box className='flexCenter' gap={0.5}>
            <Typography fontWeight='bold'>
              {commafy(off === 0 ? price : Math.floor((price * off) / 100))}
            </Typography>
            <Typography className='unit'>تومان</Typography>
          </Box>
          {off !== 0 && (
            <Typography color='text.lighter' className='priceContainer'>
              {commafy(price)}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default ProductCard;
